import {translations} from 'presentation/translations-new';
import {GetEmptyStateDescriptionProps} from './types';

const {emptyAppointment} = translations['pt-br'].privateFlow.myAppointments;

export const getAppointmentsEmptyDescription = ({
	isValid,
	isContractSuspended,
	odontoOnly,
}: GetEmptyStateDescriptionProps) => {
	const isInactive = !isValid || isContractSuspended;

	if (isInactive) {
		return odontoOnly
			? emptyAppointment.inactiveDescriptionOdonto
			: emptyAppointment.inactiveDescription;
	}

	return odontoOnly ? emptyAppointment.descriptionOdonto : emptyAppointment.description;
};
